import { render } from "./BaseTrendMetric.vue?vue&type=template&id=548ab760"
import script from "./BaseTrendMetric.vue?vue&type=script&lang=js"
export * from "./BaseTrendMetric.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BaseTrendMetric.vue"]])

export default __exports__